<div class="block w-full p-3 border border-gray-200 rounded-lg" [ngClass]="isDisabled? 'bg-gray-100': 'bg-white'">
    <div class="w-full flex justify-between bg-inherit">
        <h5 class="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">{{"recurringjob.edit_recurring_jobs.future_recurring_job" | translate}}</h5>
        <div class="bg-inherit">
            <div class="flex space-x-4 items-center bg-inherit">
                @if(isLoading){
                    <span>
                        {{'text.processing' | translate}} {{processedCount}} {{'of.label' | translate}} {{totalCount}}
                    </span>
                }
                @if(!isLoading){
                    <span>
                        {{'text.page' | translate}} {{currentPage}} {{'of.label' | translate}} {{totalPage}} 
                    </span>
                }
                <div class="inline-flex bg-inherit" role="group">
                    <button 
                        type="button" 
                        (click)="prevPage()" 
                        [disabled]="isLoading"
                        class=" text-base font-medium text-gray-900 bg-inherit rounded-full px-2 py-3 flex items-center justify-center"
                        [ngClass]="{'cursor-default': this.currentPage === 1 || isLoading, 'cursor-pointer hover:bg-gray-100': this.currentPage !== 1 && !isLoading}"
                        >
                        <mat-icon 
                            [svgIcon]="'heroicons_outline:chevron-left'" 
                            class="text-base h-6 min-h-6 text-gray-700"
                            [ngClass]="{'text-gray-400 cursor-default': this.currentPage === 1 || isLoading, 'text-gray-700': this.currentPage !== 1 && !isLoading}"
                            ></mat-icon>
                    </button>
                    <button 
                        type="button" 
                        (click)="nextPage()" 
                        [disabled]="isLoading"
                        class=" text-base font-medium bg-inherit  rounded-full  px-2 py-3 flex items-center justify-center"
                        [ngClass]="{'cursor-default': this.currentPage === totalPage || isLoading, 'cursor-pointer hover:bg-gray-100': this.currentPage !== totalPage && !isLoading}"
                        >
                        <mat-icon 
                            [svgIcon]="'heroicons_outline:chevron-right'" 
                            class="text-base h-6 min-h-6 "
                            [ngClass]="{'text-gray-400 cursor-default': this.currentPage === totalPage || isLoading, 'text-gray-700': this.currentPage !== totalPage && !isLoading}"
                            ></mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Loading Progress Bar -->
    @if(isLoading){
    <div class="w-full mt-2">                         
        <div class="w-full bg-gray-200 rounded-full h-2.5"> 
            <div class="bg-blue-600 h-2.5 rounded-full" [style.width.%]="(processedCount / totalCount) * 100"></div>
        </div>
    </div>
    }

    @if (names?.controls?.length > 0 && optimizedTemplateArray.length > 0) {
        <form [formGroup]="dateGroup" class="date-container zuper-scrollbar bg-inherit">
          <div *ngFor="let index of optimizedTemplateArray; index as i" class="bg-inherit" 
               [ngClass]="{'hidden': !names?.controls[index]?.value?.shouldDisplay}">
            <div class="grid grid-cols-3 gap-x-4 mt-3 bg-inherit"
                *ngIf="names?.controls[index]">
              @if (names.controls[index]?.value?.shouldDisplay) {
                <ng-container [formGroup]="names.controls[index]" class="bg-inherit">
                  <div class="col-span-1 p-2 bg-inherit">
                    <label class="block text-base font-medium text-gray-700">
                      {{"recurrence.label.job_date" | translate}}
                      <span class="mandatory-field">*</span>
                    </label>
                    <input [matDatepicker]="date" type="text" name="date" id="date" formControlName="date"
                      class="mt-1 block w-full rounded-md border border-gray-300 focus:border-indigo-500 bg-inherit shadow-sm px-3 py-3 leading-none text-base cursor-pointer"
                      placeholder="{{'recurrence.placeholder.pick_job_date' | translate}}" (click)="date.open()"
                      [datePickerFormat]="dateFormat">
                    <mat-datepicker #date></mat-datepicker>
                    <p class="text-red-500 text-base mt-1"
                      *ngIf="utilityService.getErrorMessage(names.controls[index], 'date')">
                      {{utilityService.getErrorMessage(names.controls[index], 'date') | translate}}
                    </p>
                  </div>
                  <div class="col-span-1 p-2 bg-inherit">
                    <label class="block text-base font-medium text-gray-700">
                      {{"text.job_start_time" | translate}}
                      <span class="mandatory-field">*</span>
                    </label>
                    <input [matMenuTriggerFor]="startTime" type="text" [name]="'startTime'" readonly [id]="'startTime'"
                      [formControlName]="'startTime'"
                      class="mt-1 block w-full rounded-md border border-gray-300 focus:border-indigo-500 bg-inherit shadow-sm px-3 py-3 leading-none text-base cursor-pointer"
                      placeholder="{{'recurrence.placeholder.time' | translate}}">
                    <mat-menu #startTime="matMenu">
                      <div class="flex flex-col">
                        <div class="flex justify-center">
                          <ngx-mat-timepicker #startTimePicker (click)="$event.stopPropagation()" [showSpinners]="true"
                            [stepHour]="1"
                            [stepMinute]="names.controls[index].value.startTimeStepperMin"
                            [showSeconds]="false" [enableMeridian]="enableMeridian"
                            [(ngModel)]="timepickerStart[index]"
                            [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="setStartTimeControl('startTime', index)">
                          </ngx-mat-timepicker>
                        </div>
                      </div>
                    </mat-menu>
                    <p class="text-red-500 text-base mt-1"
                      *ngIf="utilityService.getErrorMessage(names.controls[index], 'startTime')">
                      {{utilityService.getErrorMessage(names.controls[index], 'startTime') | translate}}
                    </p>
                  </div>
                  <div class="col-span-1 p-2 bg-inherit">
                    <div>
                      <label class="block text-base font-medium text-gray-700">
                        {{"text.job_end_time" | translate}}
                        <span class="mandatory-field">*</span>
                      </label>
                      <div class="flex">
                        <input [matMenuTriggerFor]="endTime" type="text" [name]="'endTime'" readonly [id]="'endTime'"
                          [formControlName]="'endTime'"
                          class="mt-1 block w-full rounded-md border border-gray-300 focus:border-indigo-500 bg-inherit shadow-sm px-3 py-3 leading-none text-base cursor-pointer"
                          placeholder="{{'recurrence.placeholder.time' | translate}}">
                        <mat-menu #endTime="matMenu">
                          <div class="flex flex-col">
                            <div class="flex justify-center">
                              <ngx-mat-timepicker #endTimePicker (click)="$event.stopPropagation()" [showSpinners]="true"
                                [stepHour]="1"
                                [stepMinute]="names.controls[index].value.endTimeStepperMin"
                                [showSeconds]="false" [enableMeridian]="enableMeridian"
                                [(ngModel)]="timepickerEnd[index]"
                                [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="setEndTimeControl('endTime', index)">
                              </ngx-mat-timepicker>
                            </div>
                          </div>
                        </mat-menu>
                        <span (click)="removeDate(index)"
                          class="rounded-full flex justify-center items-center text-red-600 hover:bg-red-200 h-10 w-10 p-2 ml-3 mt-1.5 cursor-pointer">
                          <i class="ti ti-trash text-xl"></i>
                        </span>
                      </div>
                      <p class="text-red-500 text-base mt-1"
                        *ngIf="utilityService.getErrorMessage(names.controls[index], 'endTime')">
                        {{utilityService.getErrorMessage(names.controls[index], 'endTime') | translate}}
                      </p>
                    </div>
                  </div>
                </ng-container>
              }
            </div>
            <p class="text-red-500 text-base mt-1 ml-3"
              *ngIf="dateValidator(index)">{{"field.min_time.error.message"| translate}}</p>
          </div>
        </form>
      }
      @else {
        <div class="flex justify-center items-center bg-inherit mt-2">
          <p class="text-gray-700 text-base font-medium primary-font">{{'recurringjob.edit_recurring_jobs.no_future_recurring_job' | translate}}</p>
        </div>
      }
</div>